import { LoaderCircle } from "lucide-react";

import type { JobStage } from "@wendo/contracts";

const STAGE_COPY: Readonly<Record<JobStage, string>> = {
  CREATED: "正在创建任务",
  QUEUED: "任务已进入处理流程",
  INSPECTING_INPUT: "正在检查 PDF",
  SELECTING_ENGINE: "正在选择转换引擎",
  CONVERTING: "正在转换为 Word",
  VALIDATING_OUTPUT: "正在校验 DOCX",
  COMPLETED: "转换完成",
};

export function ConversionProgress({
  progress,
  stage,
}: {
  readonly progress: number;
  readonly stage?: JobStage;
}) {
  return (
    <section className="status-panel processing-panel" aria-live="polite">
      <span className="processing-orb">
        <LoaderCircle size={43} />
      </span>
      <h2>{stage === undefined ? "正在创建任务" : STAGE_COPY[stage]}</h2>
      <p>请保持当前页面打开，我们会自动更新进度</p>
      <div className="progress-track large" aria-label="转换进度">
        <span style={{ width: `${Math.max(5, progress)}%` }} />
      </div>
      <strong className="progress-number">{Math.max(5, progress)}%</strong>
    </section>
  );
}
